<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-chip
        v-on="on"
        class="pl-2 pr-2"
        :color="color"
        small
        :label="label && !loading"
        :text-color="textColor"
        v-observe-visibility="visibilityChanged"
      >
        <v-progress-circular
          indeterminate
          :color="textColor"
          size="16"
          width="2"
          v-if="loading"
        />
        <template v-else>
          {{ groupContactsCount }}
        </template>
      </v-chip>
    </template>
    <div>Contacts</div>
  </v-tooltip>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'GroupContactsCountBadge',
  props: {
    group: {
      type: Object,
      required: true,
    },
    label: Boolean,
    color: String,
    textColor: {
      type: String,
      default: 'appMain',
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    groupId(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        this.checkGroupContactsInfo();
      }
    },
  },
  computed: {
    ...mapGetters(['singleGroupContactsInfo']),
    groupId() {
      return this.group?.id;
    },
    groupContactsCount() {
      const group = this.groupContactsInfo || {};
      return (group.count || 0).toLocaleString('en-US');
    },
    groupContactsInfo() {
      return this.singleGroupContactsInfo(this.groupId);
    },
  },
  methods: {
    ...mapActions(['loadGroupContacts']),
    async checkGroupContactsInfo() {
      if (this.groupContactsInfo || !this.groupId) return;

      try {
        this.loading = true;
        await this.loadGroupContacts({ group: this.group, countOnly: true });
      } finally {
        this.loading = false;
      }
    },

    visibilityChanged(isVisible) {
      if (!isVisible) return;
      this.checkGroupContactsInfo();
    },
  },
};
</script>
